import { cn } from "@/lib/utils";
import React, { CSSProperties } from "react";

function ScreenLayout({
  children,
  className,
  outerClassName,
  style,
}: {
  children: React.ReactNode;
  className?: string;
  outerClassName?: string;
  style?: CSSProperties;
}) {
  return (
    <div className={cn(outerClassName)} style={style}>
      <div
        className={cn(
          "max-w-[105rem] mx-auto px-5 sm:px-10 lg:px-12 xl:px-16",
          className
        )}
      >
        {children}
      </div>
    </div>
  );
}

export default ScreenLayout;
